export const getTabMainItems = (componentData) => {
    const data = {};
    data.id = componentData?.fields?.id;
    data.tabs = componentData?.fields?.elements?.map(e => {return {title: e?.fields?.title, elements: e?.fields?.elements, id: e?.sys?.id, bgColor: e?.fields.bgColor, imageTitle: e?.fields?.image?.fields?.title, imageUrl: e?.fields?.image?.fields?.file?.url};});
    data.bgColor = componentData?.fields?.backgroundColour;
    data.anchorId = componentData?.fields?.anchorName;
    return data;
};
